import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { MatPageable, PageableResponse } from '@core/table/mat-table';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { buildQueryString } from '@shared/util/util';

const baseRef = 'entidade-cargo';
const route = {
  deleteEntidadeCargo: (idCargo: any,idEntidade:any) => `${baseRef}/remover/${idCargo}/${idEntidade}`,
}

@Injectable({
  providedIn: 'root'
})
export class EntidadeCargoService {

  constructor(
    private apiService: ApiService,
    private http: HttpClient
  ) { }



  deleteEntidadeCargo(obj: any, id: any): Observable<any> {
    return this.apiService.delete(`${route.deleteEntidadeCargo(obj.id,id)}`, null)
  }
}
